import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { HugeiconsIcon } from "@hugeicons/react";
import { Image02Icon } from "@hugeicons/core-free-icons";
import PageTitle from '../../../jsx/layouts/PageTitle';
import ConfirmModal from "./ConfirmModal";
import { updateEditProfileById, submitEditProfileDecision } from "../../../services/adminApiService/editProfileApi/editProfileApis";
import { toast } from 'react-toastify';

const EditProfileRequestView = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [previousUser, setPreviousUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [parsedMetaValue, setParsedMetaValue] = useState(null);

  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);

  useEffect(() => {
    const fetchDataById = async () => {
      try {
        setLoading(true);
        console.log("Fetching data for ID:", id);
        const response = await updateEditProfileById(id);
        const apiData = response.data.data;
        setData(apiData);

        // Parse meta_value
        if (apiData.meta_value) {
          try {
            const parsed = JSON.parse(apiData.meta_value);
            setParsedMetaValue(parsed);
          } catch (e) {
            console.error("Error parsing meta_value:", e);
          }
        }

        setPreviousUser(apiData);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching data by ID:", error);
        setLoading(false);
      }
    };
    fetchDataById();
  }, [id]);
  // console.log("previousUser", previousUser); // Commenting out debug log
  const isSupportStaff = String(previousUser?.category_type) === '2';

  const getDocumentUrl = (docFile) => {
    if (!docFile) return null;
    const rawBase = process.env.REACT_APP_BASE_URL + "/storage" || '';
    const base = rawBase.replace(/\/+$/, '');
    const path = String(docFile).replace(/^\/+/, '');
    return base ? `${base}/${path}` : `/${path}`;
  };

  const getDocumentDetails = (documentKey) => {
    if (!documentKey || !data?.document_details) return null;
    return data.document_details[documentKey];
  };

  /* --- Helper Component for Document View --- */
  const DocumentView = ({ docKey, label = "Upload Supportive Document" }) => {
    const details = getDocumentDetails(docKey);
    return (
      <Col xs={12}>
        <label className="form-label" style={{ fontWeight: 500 }}>{label} <span className="text-danger">*</span></label>
        <div className="d-flex align-items-center gap-2">
          <div
            style={{
              width: 60,
              height: 60,
              borderRadius: 8,
              border: "1px solid #E5E7EB",
              background: "#F9FAFB",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            {details ? (
              <img
                src={getDocumentUrl(details.doc_file)}
                alt="document"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <HugeiconsIcon icon={Image02Icon} className="text-muted" />
            )}
          </div>
          {details && (
            <a
              href={getDocumentUrl(details.doc_file)}
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline-secondary btn-sm"
            >
              View
            </a>
          )}
          <span className="text-muted small">
            {details ? "Selected File" : "No File Chosen"}
          </span>
        </div>
      </Col>
    );
  };

  const renderProfileImageSection = () => {
    if (!parsedMetaValue?.profile_image) return null;
    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">Profile Image</h6>
        <Row className="g-3">
          <DocumentView docKey="profile_image" />
        </Row>
      </div>
    );
  };


  const renderNameSection = () => {
    if (!parsedMetaValue?.name) return null;
    const { first_name, middle_name, last_name, name_of_legel_entity } = parsedMetaValue.name;

    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <Row className="g-3">
          {name_of_legel_entity ? (
            <Col md={12}>
              <label className="form-label fw-bold">Center Name</label>
              <input className="form-control" value={name_of_legel_entity || ''} readOnly disabled />
            </Col>
          ) : (
            <>
              <Col md={4}>
                <label className="form-label fw-bold">First Name</label>
                <input className="form-control" value={first_name || ''} readOnly disabled />
              </Col>
              <Col md={4}>
                <label className="form-label fw-bold">Middle Name</label>
                <input className="form-control" value={middle_name || ''} readOnly disabled />
              </Col>
              <Col md={4}>
                <label className="form-label fw-bold">Last Name</label>
                <input className="form-control" value={last_name || ''} readOnly disabled />
              </Col>
            </>
          )}
          {!name_of_legel_entity && <DocumentView docKey="name_image" />}
        </Row>
      </div >
    );
  };

  const renderAddressSection = () => {
    if (!parsedMetaValue?.address) return null;
    const { city_name, pincode, landmark, city, address } = parsedMetaValue.address;

    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">Address</h6>
        <Row className="g-3">
          <Col md={4}>
            <label className="form-label fw-bold">District</label>
            <input className="form-control" value={city_name || city || ''} readOnly disabled />
          </Col>
          <Col md={4}>
            <label className="form-label fw-bold">Pincode</label>
            <input className="form-control" value={pincode || ''} readOnly disabled />
          </Col>
          <Col md={4}>
            <label className="form-label fw-bold">Landmark</label>
            <input className="form-control" value={landmark || ''} readOnly disabled />
          </Col>
          <Col md={6}>
            <label className="form-label fw-bold">Full Address</label>
            <input className="form-control" value={address || ''} readOnly disabled />
          </Col>
          <DocumentView docKey="address_image" />
        </Row>
      </div>
    );
  };

  const renderDOBSection = () => {
    if (!parsedMetaValue?.date_of_birth) return null;
    const { dob } = parsedMetaValue.date_of_birth;
    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">Date of Birth</h6>
        <Row className="g-3">
          <Col md={4}>
            <label className="form-label fw-bold">New DOB</label>
            <input className="form-control" value={dob || ''} readOnly disabled />
          </Col>
          <DocumentView docKey="dob_image" />
        </Row>
      </div>
    );
  };

  const getDocumentImageUrl = (docFile) => {
    if (!docFile) return null;
    const baseUrl = process.env.REACT_APP_BASE_URL + "/storage" || '';
    const normalizedBase = baseUrl.replace(/\/+$/, '');
    const normalizedPath = String(docFile).replace(/^\/+/, '');
    return normalizedBase ? `${normalizedBase}/${normalizedPath}` : `/${normalizedPath}`;
  };

  const renderKitSizeSection = () => {
    if (!parsedMetaValue?.kit_size) return null;
    const { kit_size, kit_name } = parsedMetaValue.kit_size;
    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">Kit Size</h6>
        <Row className="g-3">
          <Col md={4}>
            <label className="form-label fw-bold">Kit Size</label>
            <input className="form-control" value={kit_name || kit_size || ''} readOnly disabled />
          </Col>

        </Row>
      </div>
    );
  };

  const renderShoeSizeSection = () => {
    if (!parsedMetaValue?.shoe_size) return null;
    const { shoe_size } = parsedMetaValue.shoe_size;
    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">Shoe Size</h6>
        <Row className="g-3">
          <Col md={4}>
            <label className="form-label fw-bold">Shoe Size</label>
            <input className="form-control" value={shoe_size || ''} readOnly disabled />
          </Col>
          <DocumentView docKey="shoe_size_image" />
        </Row>
      </div>
    );
  };

  const renderBankDetailsSection = () => {
    if (!parsedMetaValue?.bank_details) return null;
    const { bank_name, account_holder_name, bank_account_number, branch_name, ifsc_code } = parsedMetaValue.bank_details;

    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">Bank Details</h6>
        <Row className="g-3">
          <Col md={4}>
            <label className="form-label fw-bold">Bank Name</label>
            <input className="form-control" value={bank_name || ''} readOnly disabled />
          </Col>
          <Col md={4}>
            <label className="form-label fw-bold">Account Holder</label>
            <input className="form-control" value={account_holder_name || ''} readOnly disabled />
          </Col>
          <Col md={4}>
            <label className="form-label fw-bold">Account Number</label>
            <input className="form-control" value={bank_account_number || ''} readOnly disabled />
          </Col>
          <Col md={4}>
            <label className="form-label fw-bold">Branch</label>
            <input className="form-control" value={branch_name || ''} readOnly disabled />
          </Col>
          <Col md={4}>
            <label className="form-label fw-bold">IFSC Code</label>
            <input className="form-control" value={ifsc_code || ''} readOnly disabled />
          </Col>
          <DocumentView docKey="cancelled_cheque_or_passbook" label="Cancelled Cheque / Passbook" />
        </Row>
      </div>
    );
  };

  const renderEducationSection = () => {
    if (!parsedMetaValue?.education) return null;
    const qualifications = Object.keys(parsedMetaValue.education);

    // Map shortform keys to full names
    const educationLevelMap = {
      tenth: "10th Standard",
      twelfth: "12th Standard",
      ug: "Under Graduate",
      pg: "Post Graduate",
      phd: "PhD",
      tc: "Transfer"
    };

    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">Education Details</h6>
        {qualifications.map(qual => {
          const displayName = educationLevelMap[qual] || qual;
          return (
            <Row key={qual} className="g-3 mb-3 border-bottom pb-3">
              <Col xs={12}>
              </Col>
              <DocumentView docKey={qual} label={`${displayName} Certificate`} />
            </Row>
          );
        })}
      </div>
    );
  };

  const renderIdentificationSection = () => {
    if (!parsedMetaValue?.identification) return null;
    const { identity_type, identity_card } = parsedMetaValue.identification;

    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">Identification</h6>
        <Row className="g-3">
          <Col md={6}>
            <label className="form-label fw-bold">Identification Type</label>
            <input className="form-control" value={identity_type || ''} readOnly disabled />
          </Col>
          <Col md={6}>
            <label className="form-label fw-bold">Identification Number</label>
            <input className="form-control" value={identity_card || ''} readOnly disabled />
          </Col>
          <DocumentView docKey={identity_type} label={`${identity_type} Document`} />
        </Row>
      </div>
    );
  };

  const renderSportsAchievementSection = () => {
    if (!parsedMetaValue?.sports_achievement) return null;
    const { sports_achievement, sport_id, sport_name } = parsedMetaValue.sports_achievement;

    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">{sport_id ? 'Sports' : 'Sport Achievement'}</h6>
        <Row className="g-3">
          {sport_id && (
            <Col md={12}>
              <label className="form-label fw-bold">{sport_id ? 'Sports' : 'Sport Achievement'}</label>
              <input className="form-control" value={sport_name || sport_id || ''} readOnly disabled />
            </Col>
          )}
          <DocumentView docKey="sports_achievement" label={sport_id ? 'Sports Document' : 'Sports Achievement Document'} />
        </Row>
      </div>
    );
  };

  const renderMaritalStatusSection = () => {
    if (!parsedMetaValue?.maritial_status) return null;
    const { maritial_status } = parsedMetaValue.maritial_status;

    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">Marital Status</h6>
        <Row className="g-3">
          <Col md={12}>
            <label className="form-label fw-bold">Status</label>
            <input className="form-control" value={maritial_status || ''} readOnly disabled />
          </Col>
        </Row>
      </div>
    );
  };

  const renderCenterContactPersonSection = () => {
    if (!parsedMetaValue?.contact_person_details) return null;
    const { contact_person_name } = parsedMetaValue.contact_person_details;

    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">Center Contact Person</h6>
        <Row className="g-3">
          <Col md={12}>
            <label className="form-label fw-bold">New Contact Person Name</label>
            <input className="form-control" value={contact_person_name || ''} readOnly disabled />
          </Col>
          <DocumentView docKey="center_contact_person_name_image" />
        </Row>
      </div>
    );
  };

  const renderCenterDetailsSection = () => {
    const centerDetails = parsedMetaValue?.center_details || {};
    const centerCityDetails = parsedMetaValue?.center_city_details || {};
    const hasCenterDetails = Object.keys(centerDetails).length > 0;
    const hasCenterCityDetails = Object.keys(centerCityDetails).length > 0;
    if (!hasCenterDetails && !hasCenterCityDetails) return null;

    const { district, orgnization_id, name_of_organization, contact_person_name, mobile, center_district_name, center_type_name, center_name, district_name, center_name_text } = centerDetails;
    const { city, city_name } = centerCityDetails;

    return (
      <div className="border rounded mb-4 p-3 bg-white shadow-sm">
        <h6 className="mb-3 text-primary fw-bold">Center Details</h6>
        <Row className="g-3">
          {(orgnization_id || center_type_name) && (
            <Col md={4}>
              <label className="form-label fw-bold">Center Type</label>
              <input className="form-control" value={center_type_name || orgnization_id || ''} readOnly disabled />
            </Col>
          )}
          {(city || city_name || district || center_district_name) && (
            <Col md={4}>
              <label className="form-label fw-bold">Center District</label>
              <input className="form-control" value={city_name || center_district_name || district_name || ''} readOnly disabled />
            </Col>
          )}
          {(name_of_organization || center_name) && (
            <Col md={4}>
              <label className="form-label fw-bold">Center Name</label>
              <input className="form-control" value={center_name_text || center_name || ''} readOnly disabled />
            </Col>
          )}
          {contact_person_name && (
            <Col md={4}>
              <label className="form-label fw-bold">Contact Person</label>
              <input className="form-control" value={contact_person_name || ''} readOnly disabled />
            </Col>
          )}
          {mobile && (
            <Col md={4}>
              <label className="form-label fw-bold">Mobile</label>
              <input className="form-control" value={mobile || ''} readOnly disabled />
            </Col>
          )}
          {getDocumentDetails("center_doc") && <DocumentView docKey="center_doc" />}
        </Row>
      </div>
    );
  };

  const getStatusBadge = () => {
    const status = data?.status?.toLowerCase() || "pending";
    let bgColor = "#FEF3C7";
    let textColor = "#F59E0B";
    let icon = "bi-clock-history";

    if (status === "approved") {
      bgColor = "#D1FAE5";
      textColor = "#10B981";
      icon = "bi-check-circle-fill";
    } else if (status === "reject" || status === "rejected") {
      bgColor = "#FEE2E2";
      textColor = "#EF4444";
      icon = "bi-x-circle-fill";
    }

    return (
      <div className="d-flex align-items-center gap-2 mb-3">
        <i className={`bi ${icon}`} style={{ color: textColor, fontSize: '20px' }}></i>
        <span
          style={{
            backgroundColor: bgColor,
            color: textColor,
            padding: "6px 16px",
            borderRadius: "16px",
            fontSize: "14px",
            fontWeight: 500,
            textTransform: "capitalize"
          }}
        >
          {data?.status || "Pending"}
        </span>
      </div>
    );
  };


  if (loading || !previousUser) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  return (
    <>
      <PageTitle activeMenu="Edit Profile Request List View" motherMenu="Edit Profile Request" />
      <div className="container py-4" style={{ background: '#FFFFFF', minHeight: '100vh', minWidth: '100%', borderRadius: 8 }}>
        <h3 className="text-primary mb-4">Edit Profile Request List</h3>


        {getStatusBadge()}


        {/* Comment if rejected or approved */}
        {data.comment && (
          <div className={`alert ${data?.status === 'approved' ? 'alert-success' : 'alert-danger'} mb-3`} role="alert">
            <strong>{data?.status == 'rejected' ? 'Reason:' : ''}</strong> {data?.comment}
          </div>
        )}


        {/* Previous User Details */}
        <div className="border rounded mb-4 p-3 position-relative" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <span className="btn btn-outline-dark position-absolute end-0 mt-2 me-3"
            style={{ color: '#2D3747', borderRadius: 18, padding: '6px 16px', fontWeight: 500, fontSize: 14 }}
            onClick={() => { window.history.back() }}
          >
            Previous
          </span>
          <h6 className="fs-4 mb-3">Previous User Details</h6>
          <div className="align-items-center mb-3">
            {!previousUser.name_of_legel_entity && (
              <div className="col-auto text-center">
                <div className="border d-inline-block mb-2 rounded" style={{ backgroundColor: "#EEEEEE", width: 80, height: 80, overflow: 'hidden' }}>
                  {previousUser.profile_image ? (
                    <img
                      src={getDocumentUrl(previousUser.profile_image)}
                      alt="Profile"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="bi bi-person-circle" style={{ fontSize: 32, color: '#9CA3AF' }}></i>
                    </div>
                  )}
                </div>
                <div className="text-center">
                  <span style={{ background: '#F4EEFD', color: '#753FC9', borderRadius: 16, padding: '4px 16px', fontWeight: 500, fontSize: 14, display: 'inline-block' }}>
                    Atom ID: {previousUser.atom_id}
                  </span>
                </div>
              </div>
            )}
            <div className="col">
              {previousUser.name_of_legel_entity ? (
                <div className="row g-3">
                  <div className="col-md-4"><div className="heading">Center Phone Number</div><div>{previousUser.mobile}</div></div>
                  <div className="col-md-4"><div className="heading">Sports Offered</div><div>{previousUser.sports_offered}</div></div>
                  <div className="col-md-4"><div className="heading">Center Contact Person Name</div><div>{previousUser.contact_person_name}</div></div>
                  <div className="col-md-4"><div className="heading">Center Name</div><div>{previousUser.name_of_legel_entity}</div></div>
                  <div className="col-md-4"><div className="heading">Center Type</div><div>{previousUser.center_type || previousUser?.organization?.center_type || 'NA'}</div></div>
                  <div className="col-md-4"><div className="heading">Center District</div><div>{previousUser.city_name || previousUser?.organization?.city_name || 'NA'}</div></div>
                </div>
              ) : (
                <>


                  <div className="row g-4">
                    <div className="col-md-4">
                      <div className="text-muted small mb-1">Full Name</div>
                      <div className="fw-semibold">
                        {`${previousUser.first_name || ''} ${previousUser.middle_name || ''} ${previousUser.last_name || ''}`.trim()}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="text-muted small mb-1">Gender</div>
                      <div className="fw-semibold">{previousUser.gender || 'NA'}</div>
                    </div>
                    <div className="col-md-4">
                      <div className="text-muted small mb-1">Email ID</div>
                      <div className="fw-semibold text-break">{previousUser.email || 'NA'}</div>
                    </div>

                    <div className="col-md-4">
                      <div className="text-muted small mb-1">Mobile Number</div>
                      <div className="fw-semibold">{previousUser.mobile || 'NA'}</div>
                    </div>
                    <div className="col-md-4">
                      <div className="text-muted small mb-1">Identification</div>
                      <div className="fw-semibold">
                        {(() => {
                          const idMap = {
                            aadhaar: "Aadhaar Card",
                            aadhaar_card: "Aadhaar Card",
                            aadhar: "Aadhaar Card",
                            pan: "PAN Card",
                            pan_card: "PAN Card",
                            driving_license: "Driving License",
                            driving_licence: "Driving License",
                            voter_id: "Voter ID",
                            passport: "Passport",
                            birth_certificate: "Birth Certificate",
                            tenth_identity: "10th Marksheet",
                          };
                          return idMap[previousUser.identity_type] || previousUser.identity_type || 'NA';
                        })()}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="text-muted small mb-1">Identification Document</div>
                      {previousUser.identity_type_url ? (
                        <a
                          href={getDocumentUrl(previousUser.identity_type_url)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-underline text-dark fw-semibold"
                        >
                          {(() => {
                            const idMap = {
                              aadhaar: "Aadhaar Card",
                              aadhaar_card: "Aadhaar Card",
                              aadhar: "Aadhaar Card",
                              pan: "PAN Card",
                              pan_card: "PAN Card",
                              driving_license: "Driving License",
                              driving_licence: "Driving License",
                              voter_id: "Voter ID",
                              passport: "Passport",
                              birth_certificate: "Birth Certificate",
                              tenth_identity: "10th Marksheet",
                            };
                            return idMap[previousUser.identity_type] || 'View Document';
                          })()}
                        </a>
                      ) : (
                        <span className="fw-semibold">NA</span>
                      )}
                    </div>

                    <div className="col-md-4">
                      <div className="text-muted small mb-1">Highest Qualification</div>
                      <div className="fw-semibold text-uppercase">
                        {(() => {
                          const qualificationMap = {
                            tenth: "10th Standard",
                            twelfth: "12th Standard",
                            ug: "Under Graduate",
                            pg: "Post Graduate",
                            phd: "PhD",
                            tc: "Transfer Certificate"
                          };
                          const val = previousUser.education_level;
                          const displayQual = qualificationMap[val] || val?.toUpperCase() || 'NA';

                          // user requested "show proper name which i uploaded the image"
                          // Assuming previousUser has education_certificate or similar if we want to link it.
                          // Based on previous code, let's check for 'education_certificate' variable if it exists in previousUser, 
                          // or if we should just show the name. 
                          // The user's prompt was "in higheset qualification dont show name in shortform or which comes in api show proper name which i uploaded the image"
                          // This implies showing the text correctly.
                          // If there's a link, we should probably include it.
                          // I'll assume previousUser.education_certificate might exist or use existing pattern.
                          // Checking previous lines... previousUser.sport_certificate exists.
                          // I will try previousUser.education_certificate.
                          return previousUser.education_certificate ? (
                            <a href={previousUser.education_certificate} target="_blank" rel="noopener noreferrer" className="doc-link">
                              {displayQual}
                            </a>
                          ) : displayQual;
                        })()}
                      </div>
                    </div>
                    {isSupportStaff && (
                      <>
                        <div className="col-md-4">
                          <div className="text-muted small mb-1">Sport</div>
                          <div className="fw-semibold">{previousUser.sport_name || previousUser.game_name || previousUser?.ref_sport?.sport_name || 'NA'}</div>
                        </div>
                        <div className="col-md-4">
                          <div className="text-muted small mb-1">Marital Status</div>
                          <div className="fw-semibold">{previousUser.maritial_status || 'NA'}</div>
                        </div>
                      </>
                    )}
                    {!isSupportStaff && (
                      <div className="col-md-4">
                        <div className="text-muted small mb-1">Sports Certificate</div>
                        <div className="fw-semibold text-decoration-underline">
                          {previousUser?.sport_certificate ? <a href={getDocumentImageUrl(previousUser?.sport_certificate)} target="_blank" rel="noopener noreferrer" className="doc-link">Sports Certificate</a> : 'NA'}
                        </div>
                      </div>
                    )}
                    {!isSupportStaff && (
                      <div className="col-md-4">
                        <div className="text-muted small mb-1">Kit Size</div>
                        <div className="fw-semibold">{previousUser.kit_size || 'NA'}</div>
                      </div>
                    )}

                    <div className="col-md-4">
                      <div className="text-muted small mb-1">Landmark</div>
                      <div className="fw-semibold">{previousUser.landmark || 'NA'}</div>
                    </div>
                    <div className="col-md-4">
                      <div className="text-muted small mb-1">Country</div>
                      <div className="fw-semibold">{previousUser.center_country_name || 'India'}</div>
                    </div>
                    <div className="col-md-4">
                      <div className="text-muted small mb-1">State</div>
                      <div className="fw-semibold">{previousUser.state_name || 'NA'}</div>
                    </div>

                    <div className="col-md-4">
                      <div className="text-muted small mb-1">City</div>
                      <div className="fw-semibold">{previousUser.city_name || 'NA'}</div>
                    </div>
                    <div className="col-md-4">
                      <div className="text-muted small mb-1">Pincode</div>
                      <div className="fw-semibold">{previousUser.pincode || 'NA'}</div>
                    </div>
                    <div className="col-md-4">
                      <div className="text-muted small mb-1">DOB</div>
                      <div className="fw-semibold">{previousUser.dob || 'NA'}</div>
                    </div>

                    <div className="col-md-12">
                      <div className="text-muted small mb-1">Full Address</div>
                      <div className="fw-semibold">{previousUser.address || 'NA'}</div>
                    </div>
                  </div>

                  <div className="mt-5">
                    <h5 className="fw-bold mb-3">Centre Details</h5>
                    <div className="row g-4">

                      <div className="col-md-4">
                        <div className="text-muted small mb-1">Center District</div>
                        <div className="fw-semibold">{previousUser.center_city_name || 'NA'}</div>
                      </div>
                      {isSupportStaff ? (
                        <>
                          <div className="col-md-4">
                            <div className="text-muted small mb-1">Center Country</div>
                            <div className="fw-semibold">{previousUser.center_country_name || 'NA'}</div>
                          </div>
                          <div className="col-md-4">
                            <div className="text-muted small mb-1">Center State</div>
                            <div className="fw-semibold">{previousUser.center_state_name || 'NA'}</div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-md-4">
                            <div className="text-muted small mb-1">Center Type</div>
                            <div className="fw-semibold">{previousUser.center_type || 'NA'}</div>
                          </div>
                          <div className="col-md-4">
                            <div className="text-muted small mb-1">Center Name</div>
                            <div className="fw-semibold">{previousUser.center_name || 'NA'}</div>
                          </div>
                        </>
                      )}

                    </div>
                  </div>

                  <div className="mt-5">
                    <h5 className="fw-bold mb-3">Bank Details</h5>
                    <div className="row g-4">
                      <div className="col-md-4">
                        <div className="text-muted small mb-1">Bank Name</div>
                        <div className="fw-semibold">{previousUser.bank_name || 'NA'}</div>
                      </div>
                      <div className="col-md-4">
                        <div className="text-muted small mb-1">Account Holder Name</div>
                        <div className="fw-semibold">{previousUser.account_holder_name || 'NA'}</div>
                      </div>
                      <div className="col-md-4">
                        <div className="text-muted small mb-1">Account Number</div>
                        <div className="fw-semibold">{previousUser.bank_account_number || 'NA'}</div>
                      </div>
                      <div className="col-md-4">
                        <div className="text-muted small mb-1">IFSC Code</div>
                        <div className="fw-semibold">{previousUser.ifsc_code || 'NA'}</div>
                      </div>
                      <div className="col-md-4">
                        <div className="text-muted small mb-1">Branch Name</div>
                        <div className="fw-semibold">{previousUser.branch_name || 'NA'}</div>
                      </div>
                    </div>
                  </div>


                </>
              )}
            </div>
          </div>
        </div>

        {/* Updated User Details */}
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="fs-4" style={{ color: "#000413" }}>Updated User Details</h6>
            <span className="badge" style={{ color: '#4AA564', borderRadius: 18, padding: '6px 16px', fontWeight: 500, fontSize: 14, border: '1px solid #4AA564' }}>
              Updated
            </span>
          </div>

          {/* Render all sections */}
          {renderProfileImageSection()}
          {renderNameSection()}
          {renderAddressSection()}
          {renderDOBSection()}
          {renderKitSizeSection()}
          {renderShoeSizeSection()}
          {renderBankDetailsSection()}
          {renderEducationSection()}
          {renderIdentificationSection()}
          {renderSportsAchievementSection()}
          {renderMaritalStatusSection()}
          {renderCenterContactPersonSection()}
          {renderCenterDetailsSection()}


          <div className="mt-4">
            {data?.status === "pending" ? (
              <div className="d-flex gap-2">
                <button
                  className="btn flex-fill py-2"
                  style={{ fontSize: 18, backgroundColor: '#C62828', color: "#F9FAFB" }}
                  onClick={() => setShowRejectModal(true)}
                >
                  Reject
                </button>
                <button
                  className="btn flex-fill py-2"
                  style={{ fontSize: 18, backgroundColor: '#4AA564', color: "#F9FAFB" }}
                  onClick={() => setShowApproveModal(true)}
                >
                  Approve
                </button>
              </div>
            ) : (

              ""
            )}
          </div>

        </div>
      </div>

      {/* Modals */}
      <ConfirmModal
        type="approve"
        show={showApproveModal}
        handleClose={() => setShowApproveModal(false)}
        onConfirm={async (remark) => {
          try {
            await submitEditProfileDecision(id, "approved");
            toast.success("Profile edit request approved successfully");
            setShowApproveModal(false);
            navigate(-1);
          } catch (error) {
            console.error("Error approving request:", error);
            toast.error("Failed to approve profile edit request");
          }
        }}
      />

      <ConfirmModal
        type="reject"
        show={showRejectModal}
        handleClose={() => setShowRejectModal(false)}
        onConfirm={async (remark) => {
          try {
            await submitEditProfileDecision(id, "rejected", remark);
            toast.success("Profile edit request rejected successfully");
            setShowRejectModal(false);
            navigate(-1);
          } catch (error) {
            console.error("Error rejecting request:", error);
            toast.error("Failed to reject profile edit request");
          }
        }}
      />
    </>
  );
};

export default EditProfileRequestView;